<div class="row">
  <div class="col-lg-12">
    <div class="card card-outline-success">
      <div class="card-header">
        <h4 class="m-b-0 text-white">Movimientos de almacén</h4>
      </div>
      <div class="card-body">
        <div class="form-body">
          <h3>Lista de todos los movimientos de almacén</h3>
          <div class="tablaMovimientos">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
              <thead>
                <tr style="text-align: center">
                  <th>Sucursal</th>
                  <th>Nombre Cliente</th>
                  <th>Contrato</th>
                  <th>Folio</th>
                  <th>Concepto</th>
                  <th>Código</th>
                  <th>Producto</th>
                  <th>A. Origen</th>
                  <th>A. Destino</th>
                  <th>Cantidad</th>
                  <th>Fecha</th>
                  <th>Usuario</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let movimiento of arrayMovimientosAlmacen" style="text-align: center">
                  <td>{{ movimiento.sucursal }}</td>
                  <td>{{ movimiento.cliente.nombre }}</td>
                  <td>{{ movimiento.contrato.noContrato }}</td>
                  <td>{{ movimiento.folio }}</td>
                  <td>{{ movimiento.concepto }}</td>
                  <td>{{ movimiento.producto.codigo }}</td>
                  <td>{{ movimiento.producto.descripcion }}</td>
                  <td>{{ movimiento.almacenOrigen }}</td>
                  <td>{{ movimiento.almacenDestino }}</td>
                  <td>{{ movimiento.cantidad }}</td>
                  <td>{{ movimiento.fecha.split('T') }}</td>
                  <td>{{ movimiento.usuario }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/movimientos-almacen/movimientos-almacen.component.html